var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"food-name"},[_c('h4',[_vm._v(_vm._s(_vm.item.name))])]),_c('div',{staticClass:"food-desc"},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.item.desc))])])]),_c('div',{staticClass:"food-price"},[_c('p',[_vm._v(_vm._s(_vm.item.price))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }